// NotFound.js
import React from "react";
import { Link } from "react-router-dom";
import NotFoundImg from "../../assets/images/notfound.png";
const NotFound = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>

      <img
            src={NotFoundImg}
            alt="Logo"
            style={{
              width: "600px",
              height: "600px",
              marginTop:'50px'
            }}
          />
    </div>
  );
};

export default NotFound;